import { render, staticRenderFns } from "./LaborRegistWorkReport.vue?vue&type=template&id=f54c9060&scoped=true&"
import script from "./LaborRegistWorkReport.vue?vue&type=script&lang=ts&"
export * from "./LaborRegistWorkReport.vue?vue&type=script&lang=ts&"
import style0 from "./LaborRegistWorkReport.vue?vue&type=style&index=0&id=f54c9060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54c9060",
  null
  
)

export default component.exports